import { render, staticRenderFns } from "./ReceiptDetail.vue?vue&type=template&id=26202e68&"
import script from "./ReceiptDetail.vue?vue&type=script&lang=ts&"
export * from "./ReceiptDetail.vue?vue&type=script&lang=ts&"
import style0 from "./ReceiptDetail.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports